import { Output, EventEmitter } from '@angular/core';
import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Fee } from '../../../models/Fee';

@Component({
  selector: 'app-edit-fee',
  standalone: false,  
  templateUrl: './edit-fee.component.html',
  styleUrl: './edit-fee.component.css'
})
export class EditFeeComponent implements OnInit {
  @Output() CloseEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() ItemSelectEmitter: EventEmitter<Fee> = new EventEmitter();
  public CurrentFee: Fee;
  public IsCreate: boolean;
  public constructor() {
    this.IsCreate = true;
  }

  ngOnInit() {
    
  }

  AddFee() {
    this.ItemSelectEmitter.emit(this.CurrentFee);
  }

  CloseWindow() {
    this.CloseEventEmitter.emit("");
  }

  AssignFeePrice(ev: any) {
    this.CurrentFee.UnitPrice = Number(ev.replace(/[^0-9.-]/g, ''));
  }
}
